<template>
    <div class="diagnosis-dialog">
        <div v-show="showContent" id="download-as-image" class="diagnosis-dialog-content" :style="getBackgroundImage()">
            <template v-if="status === 1 || status === 2">
                <h1 class="content_title">{{ status === 1 ? '恭喜你，完成诊断': '诊断已结束' }}</h1>
                <div class="content_loading">
                    <img class="content_loading_back" src="../assets/images/diagnosis-dialog-loading-back-icon.png" alt="" />
                    <img class="content_loading_front" src="../assets/images/diagnosis-dialog-loading-front-icon.png" alt="">
                </div>
                <p class="content_tips">正在统计分数，请稍等...</p>
            </template>
            <template v-if="status === 0">
                <h1 class="content_title al">{{ isPassed ? '恭喜你，顺利通过' : '暂未通过'}}</h1>
                <p class="content_text">{{ isPassed ? '快去前往学而思培优App报名吧～': '别泄气，继续努力哦～'}}</p>
                <div class="score-area" :style="{'justify-content': !isPassed ? 'space-around' : 'flex-start'}">
                    <template v-if="isPassed">
                        <div class="score-area_item left">
                            <span class="score-number">{{ diagnosisResult.levelName || diagnosisResult.levelDegreeName || ''}}</span>
                            <span class="score-text">推荐班型</span>
                            <span class="line"></span>
                        </div>
                        <div class="score-area_item">
                            <span class="score-number">{{ diagnosisResult.score }}</span>
                            <span class="score-text">诊断得分</span>
                        </div>
                    </template>
                    <template v-else>
                        <div class="score-area_item">
                            <span class="score-number low">{{ diagnosisResult.score }}</span>
                            <span class="score-text">诊断得分</span>
                        </div>
                    </template>
                </div>
                <div class="content-footer">
                    <button class="btn gray" style="margin-right: 32px;" @click="goBack">返 回</button>
                    <button class="btn orange" @click="handelConfirm">{{ isPassed ? '下载诊断结果' : '好的' }}</button>
                </div>
            </template>
            <DiagnosisReportDownload v-if="isPassed" ref="report" :diagnosisResult="diagnosisResult" />
        </div>
    </div>
</template>

<script>
import BG_1_2 from '../assets/images/diagnosis-dialog-bg-1-2.png'
import BG_3 from '../assets/images/diagnosis-dialog-bg-3.png'
import BG_4 from '../assets/images/diagnosis-dialog-bg-4.png'
import html2canvas from 'html2canvas'
import DiagnosisReportDownload from './diagnosisReportDownload.vue'
import { getDiagnosisResult } from '@/services/diagnosis'
import { errorHandler } from '@/utils/errorHandler'
import { MessageBox } from 'element-ui'
export default {
  components: {
    DiagnosisReportDownload,
  },
  props: {
    status: {
      type: Number,
      //   required: true,
      default: 0, // 1 手动交卷 2 倒计时结束收卷 0 出成绩
    },
    bundleId: {
      type: String,
      required: true,
    },
    moduleId: {
      type: String,
      required: true,
    },
  },
  computed: {
    isPassed() {
      return (
        this.diagnosisResult.levelDegreeName || this.diagnosisResult.levelName
      )
    },
  },
  data() {
    return {
      diagnosisResult: {},
      showContent: true
    }
  },
  async created() {
    this.getDiagnosisResult()
  },
  beforeDestroy() {
    clearTimeout(this.timer)
    this.timer = null
  },
  methods: {
    async getDiagnosisResult() {
      let number = 1
      ;(async function getResult(that) {
        try {
          const { data } = await getDiagnosisResult({
            bundleId: that.bundleId,
            moduleId: that.moduleId,
          })
          if (!data) {
            number++
            if (number > 6) {
              that.showContent = false
              return MessageBox.alert('暂无数据，请联系下老师', '温馨提示', {
                confirmButtonText: '返回',
                customClass: 'OptionalDialog center',
                showCancelButton: false,
                showClose: false,
                center: true,
              }).then(() => {
                // 点击挑战按钮埋点
                that.$emit('handleBack')
              })
            }
            return (that.timer = setTimeout(() => {
              that.timer && getResult(that)
            }, 3000))
          }
          that.diagnosisResult = data
          setTimeout(() => {
            that.$emit('update:status', 0)
          }, 1000)
        } catch ({ data }) {
          errorHandler(data)
        }
      })(this)
    },
    fileDownload(downloadUrl, filename) {
      let aLink = document.createElement('a')
      aLink.style.display = 'none'
      aLink.href = downloadUrl
      aLink.download = `${filename}.png` || '竞赛.png'
      // 触发点击-然后移除
      document.body.appendChild(aLink)
      aLink.click()
      document.body.removeChild(aLink)
    },
    goBack() {
      this.$emit('handleBack')
    },
    handelConfirm() {
      if (!this.isPassed) {
        return this.$emit('handleBack')
      }
      this.$nextTick(() => {
        html2canvas(this.$refs.report.$el, {
          allowTaint: true,
          useCORS: true,
        }).then((canvas) => {
          this.fileDownload(canvas.toDataURL('image/png'), '诊断报告')
        })
      })
    },
    getBackgroundImage() {
      let URL = ''
      let al = false
      switch (this.status) {
        case 1:
        case 2:
          URL = BG_1_2
          break
        case 0:
          if (this.isPassed) URL = BG_3
          else URL = BG_4
          al = true
          break
      }
      return {
        'background-image': `url(${URL})`,
        'align-items': al ? 'flex-start' : 'center',
        padding: al ? '0 42px' : '',
      }
    },
  },
}
</script>

<style>
.OptionalDialog.center .el-message-box__btns {
  justify-content: center !important;
}
</style>

<style lang="less" scoped>
@text-color: #5c2705;

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.diagnosis-dialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: rgba(12, 12, 12, 0.616);
  cursor: default;
  line-height: 1;
  &-content {
    width: 512px;
    border-radius: 12px;
    // background: #fef2e5;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-image: url('../assets/images/diagnosis-dialog-bg-1-2.png');
    background-size: 100%;
    background-repeat: no-repeat;
    overflow: hidden;

    .content_title {
      color: @text-color;
      font-size: 30px;
      margin: 32px 0 0;
    }

    .content_loading {
      margin-top: 40px;
      position: relative;
      &_back {
        animation: rotating 2s linear infinite;
        border-radius: 50%;
      }

      &_front {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .content_tips {
      margin-top: 16px;
      margin-bottom: 56px;
      color: @text-color;
      font-size: 16px;
    }

    .content_text {
      color: @text-color;
      font-size: 14px;
      margin-top: 16px;
    }

    .score-area {
      position: relative;
      margin-top: 18px;
      width: 100%;
      height: 150px;
      background: linear-gradient(176.98deg, #ffebd1 -43.12%, #ffffff 34.17%);
      border: 1px solid #ffffff;
      border-radius: 8px;
      margin-bottom: 20px;
      display: flex;
      // justify-content: space-between;
      align-items: center;

      .score-area_item {
        display: flex;
        flex-direction: column;
        align-items: center;

        &.left {
          margin-left: 32px;
          margin-right: 64px;
          width: 220px;
          position: relative;
        }

        .line {
          border-left: 1px solid #ffe2c5;
          height: 40px;
          position: absolute;
          right: -32px;
          top: 50%;
          transform: translate(0, -50%);
        }
      }

      .score-number {
        font-family: 'DIN Alternate';
        font-weight: 700;
        font-size: 30px;
        color: #fa9e00;
        background: linear-gradient(180deg, #ef6803 0%, #ec9901 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
        letter-spacing: 1.8px;
        &.low {
          background: #565d66;
          background-clip: text;
          color: transparent;
        }
      }

      .score-text {
        margin-top: 12px;
        font-size: 14px;
        color: #666;
        letter-spacing: 1.8px;
      }
    }

    .content-footer {
      box-sizing: border-box;
      background-color: #fff;
      width: 512px;
      height: 64px;
      margin: 0 -42px;
      display: flex;
      justify-content: center;
      align-items: center;

      .btn {
        height: 40px;
        border-radius: 20px;
        border: none;
        cursor: pointer;
        font-size: 16px;
        font-weight: 500;
        padding: 8px 58px;

        &.gray {
          background: #f5f6f7;
          color: #666666;
          &:hover {
            background-color: rgba(245, 246, 247, 0.9);
            &:active {
              background-color: rgba(245, 246, 247, 0.5);
            }
          }
        }

        &.orange {
          background: #fa9e00;
          color: #fff;
          &:hover {
            background-color: rgba(250, 158, 0, 0.9);
            &:active {
              background-color: rgba(250, 158, 0, 0.5);
            }
          }
        }
      }
    }
  }
}
</style>